wbApp.directive('wbAddressLookup', ['geoCoderSvc',
    function (geoCoderSvc) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                formattedAddress: '=',
                location: '=ngModel',
                wbPlaceholder: '@',
            },
            template: '<div>' +
                      '<input bs-typeahead ' + 
                              'class="form-control" ' +
                              'ng-model="addressJson" ' +
                              'ng-change="onChange(addressJson)"' +
                              'placeholder="{{wbPlaceholder}}"' +
                              'bs-options="address as address.formatted_address for address in getAddress($viewValue) track by address">' +
                      '</div>',
            replace: true,
            link: function (scope, iElem, attr, controller) {

                scope.getAddress = function (val) {
                    return geoCoderSvc.geocode(val);
                }

                function onLocationChange(val) {
                    if (val && val.longitude && val.latitude) {
                        let geo = geoCoderSvc.geoDecode(val.latitude, val.longitude);
                        geo.then(function (addresses) {
                            if (addresses.length && !angular.equals(scope.addressJson, addresses[0])) {

                                let newLocation = {
                                    latitude: addresses[0].geometry.location.lat(),
                                    longitude: addresses[0].geometry.location.lng()
                                };
                                
                               // if ((newLocation.longitude === val.latitude && newLocation.longitude === val.longitude) ||
                               //     !scope.formattedAddress) {
                                    scope.addressJson = addresses[0];
                                    scope.onChange(addresses[0]);
                              //  } else {
                              //      scope.addressJson = scope.formattedAddress;
                              //  }
                            }
                        });
                    }
                }

                scope.$watch('location', function (val) {
                    if (!scope.lastLocationUpdate) {
                        scope.lastLocationUpdate = angular.copy(val);
                        scope.addressJson = scope.formattedAddress;
                    }
                    else {
                        if (!angular.equals(scope.lastLocationUpdate, val)) {
                            scope.lastLocationUpdate = angular.copy(val);
                            onLocationChange(val);
                        }
                    }
                }, true);

                scope.onChange = function (val) {
                    if (val) {
                        if (typeof val === 'string' || val instanceof String) {
                        } else {
                            if (val.geometry && val.geometry.location) {
                                let newLocation = {
                                    latitude: val.geometry.location.lat(),
                                    longitude: val.geometry.location.lng()
                                };

                                scope.lastLocationUpdate = angular.copy(newLocation);
                                
                                if (!angular.equals(newLocation, scope.location)) {
                                    scope.location = newLocation;
                                }
                                scope.addressJson = val;
                            }
                            if (scope.formattedAddress !== val.formatted_address) {
                                scope.formattedAddress = val.formatted_address;
                            }
                        }
                    } else {
                        scope.formattedAddress = null;
                        scope.location = {
                            latitude: null, longitude: null
                        };
                    }
                }
            }
        }
    }]);